export const stateChange = (string) => { //链路监控 文本映射
  const stateObj = {
    'success': "正常",
    // 'warning':"正常",
    'fail': "失败",
    '10000': "正常",
    '20000': "正常",
    '30000': "失败",
    'default': "正常",//'未知'
  }
  return stateObj[string] || stateObj['default'];
}
export const colorStateChange = (string) => { //链路监控 文本前圆圈颜色映射
  const stateObj = {
    'success': "rgb(0, 213, 8)",
    // 'warning':"正常",
    'fail': "#F5222D",
    '10000': "rgb(0, 213, 8)",
    '20000': "#FAAD14",
    '30000': "#F5222D",
    'default': "rgb(0, 213, 8)",//'#FAAD14'
  }

  return stateObj[string] || stateObj['default'];
}
export const box_colorStateChange = (bs, string) => { //链路监控 文本和圆圈外面盒子边框颜色映射

  const stateObj = { //传not的是假数据
    '1': { //sjdt_svgbox_border => box-shadow 
      'success': "rgba(15,53,102,0.2)",
      'fail': "#F5222D",
      '10000': "rgba(15,53,102,0.2)",
      '20000': "#FAAD14",
      '30000': "#F5222D",
      'default': 'rgba(15,53,102,0.2)'
    },
    '2': { //sjdt_svgbox_border => border 
      'success': "#30B0CE",
      'fail': "#F5222D",
      '10000': "#30B0CE",
      '20000': "#FAAD14",
      '30000': "#F5222D",
      'default': '#30B0CE'
    },

  }


  return stateObj[bs][string] || stateObj[bs]['default'];
}